import { Chip } from "@mui/material";
import React, { FC } from 'react';

interface SelectContentSimpleProps {
  value: unknown;
  placeholder: string;
  search?: boolean;
  commonContent?: boolean; //если true - элемент отображается как в renderOption, иначе через Chip
  renderOption?: (option: unknown, isSelected: boolean) => JSX.Element;
  getOptionLabel?: (option: unknown) => string;
}

export const SelectContentSimple: FC<SelectContentSimpleProps> = ({
  value, placeholder, search, commonContent, renderOption, getOptionLabel,
}: SelectContentSimpleProps) => {
  if ((value === null || value === undefined || Number.isNaN(value)) && !search) { 
    return (
      <span className="placeholder">
        {placeholder}
      </span>
  );
  }
  else if (commonContent)
    return renderOption(value, false);
  return (
    <Chip
      className="chip"
      label={getOptionLabel(value) ?? ''}
    />
  );
};